
import { defineComponent, ref } from 'vue'
import PageFile from '@/components/page-file'
import PageCategory from '@/components/page-file/src/page-category.vue'
import CpnRanking from '@/components/cpn/cpn-ranking.vue'

import { IarchivesType } from '@/store/page-file/types'
export default defineComponent({
  components: { PageFile, PageCategory, CpnRanking },
  setup() {
    let category_l = ref<IarchivesType[]>([])
    let isShows = ref<boolean>(false)
    function Category(list: IarchivesType[]) {
      category_l.value = list
      isShows.value = false
    }
    function activeCFn() {
      // console.log(11)
      isShows.value = true
    }
    return {
      Category,
      category_l,
      activeCFn,
      isShows
    }
  }
})
